export const MAX_COMPARATOR_ASSETS = 5;

export const normalizeComparatorInstrument = (value: string): string | null => {
  const normalized = value
    .trim()
    .toUpperCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^A-Z0-9]/g, '');

  if (!normalized) return null;
  if (/^[A-Z]{4}$/.test(normalized)) return `${normalized}11`;
  return normalized;
};

export const parseComparatorAssets = (value: string): string[] =>
  Array.from(
    new Set(
      value
        .replace(/-vs-/gi, '.')
        .split(/[.,]/)
        .map(normalizeComparatorInstrument)
        .filter((item): item is string => item !== null && item.length >= 5),
    ),
  ).slice(0, MAX_COMPARATOR_ASSETS);

export const buildComparatorPath = (assets: string[]): string => {
  const normalized = Array.from(
    new Set(assets.map(normalizeComparatorInstrument).filter((item): item is string => Boolean(item))),
  ).slice(0, MAX_COMPARATOR_ASSETS);

  if (normalized.length === 0) return '/comparador';
  if (normalized.length === 2) {
    const [left, right] = [...normalized].sort((a, b) => a.localeCompare(b));
    return `/comparador/${left.toLowerCase()}-vs-${right.toLowerCase()}`;
  }
  return `/comparador/${normalized.map((item) => item.toLowerCase()).join('.')}`;
};

export const isCanonicalPairSlug = (slug: string, assets: string[]) =>
  assets.length === 2 && slug.toLowerCase() === buildComparatorPath(assets).slice('/comparador/'.length);
